export const neapExams = {
  EXAMS_LIST_REQUEST: "neap/EXAMS_REQUEST",
  EXAMS_LIST_REQUEST_ERROR: "neap/EXAMS_REQUEST_ERROR",
  EXAMS_LIST_REQUEST_SUCCESS: "neap/EXAMS_REQUEST_SUCCESS",
};

export const endpoints = {
  EXAMS_LIST: `/neap-tests/v1/scheduled/list`,
};
